import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { AuditItemLogService } from 'app/service/audit-item-log-service';
import { AuditorBenchAuditDetailScopeDetailDTO } from 'app/model/auditor-bench-audit-detail-scope-detail-dto';
import { CommonDTO } from './../../../model/common-dto';
import { CustomMessages } from '@shared';
import { MatTableDataSource } from '@angular/material/table';

export interface PeriodicElement {
  orderId: string;
  executiveSummary: string;
  subObservationParentId: string;
  ratingMstId: string;
  includeInReport: string;
  auditorObservation: string;
  impactComments: string;
  recommendation: string;
}

@Component({
  selector: 'app-audititemlog',
  templateUrl: './audititemlog.component.html',
  styleUrls: ['./audititemlog.component.scss'],
})
export class AudititemlogComponent implements OnInit {
  public styleObj = {
    'vertical-align': 'text-top',
    // "word-break": "break-all"
  };
  public styleObj2 = {
    'vertical-align': 'text-top',
    // "word-break": "break-all"
  };
  [x: string]: any;
  displayedColumns: string[] = [
    'orderId',
    'executiveSummary',
    'subObservationParentId',
    'ratingMstId',
    'includeInReport',
    'auditorObservation',
    'impactComments',
    'recommendation',
    'modifiedBy',
    'modifiedOn',
  ];
  dataSource = new MatTableDataSource();
  ELEMENT_DATA: PeriodicElement[] = [];
  escalationChange: boolean = false;
  observationApplicableChange: boolean = false;
  ratingMstIdChange: boolean = false;
  includeInReportChange: boolean = false;
  auditorObservationChange: boolean = false;
  impactCommentsChange: boolean = false;
  recommendationChange: boolean = false;
  modifiedByChange: boolean = false;
  modifiedOnChange: boolean = false;
  managementCommentChange: boolean = false;
  targetDateChange: boolean = false;
  pdcaActionChange: boolean = false;
  persistenceCommentsChange: boolean = false;
  revisedTargetDateChange: boolean = false;
  rcoCommentsChange: boolean = false;
  noList: boolean = true;

  parsedJson: any;
  noRecordFound: boolean = false;
  sectionId: any;
  scopeDesc: string;
  departmentName: string;
  sectionName: string;
  constructor(
    private auditItemLogService: AuditItemLogService,
    private customMessages: CustomMessages
  ) {}

  auditorBenchAuditDetailScopeDetailList: AuditorBenchAuditDetailScopeDetailDTO[];
  commonDTO: CommonDTO = new CommonDTO();
  @Output() closePanelAudiItemLog: EventEmitter<boolean> = new EventEmitter();
  @Input() auditItemId: string;
  @Input() isWorkflowBased: boolean;
  @Input() callingType: string;

  ngOnInit() {
    this.getAuditItemLogList();
  }
  getAuditItemLogList() {
    if (this.isWorkflowBased == false) {
      this.commonDTO.searchValue = 'All';
    } else {
      this.commonDTO.searchValue = this.callingType;
    }
    this.commonDTO.scopeId = this.auditItemId;

    //this.commonDTO.searchValue = this.callingType;//del
    if (this.commonDTO.searchValue === 'Auditor') {
      //NC-NC Finalize
      this.displayedColumns = [
        'orderId',
        'executiveSummary',
        'subObservationParentId',
        'ratingMstId',
        'includeInReport',
        'auditorObservation',
        'impactComments',
        'recommendation',
        'modifiedBy',
        'modifiedOn',
      ];
    } else if (this.commonDTO.searchValue === 'Auditee') {
      //CM- Closing Meeting
      this.displayedColumns = [
        'orderId',
        'managementResponse',
        'auditeeTargetDate',
        'cdPdcaStatus',
        'persistenceManagementResponse',
        'auditeeRevisedTargetDate',
        'rcoComments',
        'modifiedBy',
        'modifiedOn',
      ];
    } else {
      this.displayedColumns = [
        'orderId',
        'executiveSummary',
        'subObservationParentId',
        'ratingMstId',
        'includeInReport',
        'auditorObservation',
        'impactComments',
        'recommendation',
        'managementResponse',
        'auditeeTargetDate',
        'cdPdcaStatus',
        'persistenceManagementResponse',
        'auditeeRevisedTargetDate',
        'rcoComments',
        'modifiedBy',
        'modifiedOn',
      ];
    }
    this.auditItemLogService.getAuditItemsLogList(this.commonDTO).subscribe(
      data => {
        if (data == null || data == '') {
          this.noList = true;
        } else {
          this.noList = false;
          this.parsedJson = JSON.parse(JSON.stringify(data));
          this.auditorBenchAuditDetailScopeDetailList = this.parsedJson;
          this.sectionId = this.auditorBenchAuditDetailScopeDetailList[0].sectionId;
          this.sectionName = this.auditorBenchAuditDetailScopeDetailList[0].sectionName;
          this.departmentName = this.auditorBenchAuditDetailScopeDetailList[0].departmentName;
          this.scopeDesc = this.auditorBenchAuditDetailScopeDetailList[0].scopeDescription;
          this.noRecordFound = false;
          this.ELEMENT_DATA = this.auditorBenchAuditDetailScopeDetailList;
          this.dataSource = new MatTableDataSource(this.ELEMENT_DATA);
        }
      },
      error => {
        //this.error = error;
        this.customMessages.showErrorMessage(error.error.msgId, error.error.message);
      }
    );
  }

  closed() {
    this.closePanelAudiItemLog.emit(false);
  }
  getClassByValue(index: number) {
    this.escalationChange = false;
    this.observationApplicableChange = false;
    this.ratingMstIdChange = false;
    this.includeInReportChange = false;
    this.auditorObservationChange = false;
    this.impactCommentsChange = false;
    this.recommendationChange = false;
    this.modifiedByChange = false;
    this.modifiedOnChange = false;
    if (index < this.auditorBenchAuditDetailScopeDetailList.length - 1) {
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].executiveSummary !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].executiveSummary
      ) {
        this.escalationChange = true;
      } else {
        this.escalationChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].subObservationParentId !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].subObservationParentId
      ) {
        this.observationApplicableChange = true;
      } else {
        this.observationApplicableChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].ratingMstId !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].ratingMstId
      ) {
        this.ratingMstIdChange = true;
      } else {
        this.ratingMstIdChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].includeInReport !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].includeInReport
      ) {
        this.includeInReportChange = true;
      } else {
        this.includeInReportChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].auditorObservation !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].auditorObservation
      ) {
        this.auditorObservationChange = true;
      } else {
        this.auditorObservationChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].impactComments !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].impactComments
      ) {
        this.impactCommentsChange = true;
      } else {
        this.impactCommentsChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].recommendation !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].recommendation
      ) {
        this.recommendationChange = true;
      } else {
        this.recommendationChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].modifiedBy !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].modifiedBy
      ) {
        this.modifiedByChange = true;
      } else {
        this.modifiedByChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].modifiedOn !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].modifiedOn
      ) {
        this.modifiedOnChange = true;
      } else {
        this.modifiedOnChange = false;
      }
    }
    return this.escalationChange;
  }
  getClassByValueAuditee(index: number) {
    this.managementCommentChange = false;
    this.targetDateChange = false;
    this.pdcaActionChange = false;
    this.persistenceCommentsChange = false;
    this.revisedTargetDateChange = false;
    this.rcoCommentsChange = false;

    if (index < this.auditorBenchAuditDetailScopeDetailList.length - 1) {
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].managementResponse !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].managementResponse
      ) {
        this.managementCommentChange = true;
      } else {
        this.managementCommentChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].auditeeTargetDate !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].auditeeTargetDate
      ) {
        this.targetDateChange = true;
      } else {
        this.targetDateChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].cdPdcaStatus !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].cdPdcaStatus
      ) {
        this.pdcaActionChange = true;
      } else {
        this.pdcaActionChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].persistenceManagementResponse !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].persistenceManagementResponse
      ) {
        this.persistenceCommentsChange = true;
      } else {
        this.persistenceCommentsChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].auditeeRevisedTargetDate !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].auditeeRevisedTargetDate
      ) {
        this.revisedTargetDateChange = true;
      } else {
        this.revisedTargetDateChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].rcoComments !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].rcoComments
      ) {
        this.rcoCommentsChange = true;
      } else {
        this.rcoCommentsChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].modifiedBy !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].modifiedBy
      ) {
        this.modifiedByChange = true;
      } else {
        this.modifiedByChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].modifiedOn !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].modifiedOn
      ) {
        this.modifiedOnChange = true;
      } else {
        this.modifiedOnChange = false;
      }
    }
    return this.managementCommentChange;
  }

  getClassByValueAll(index: number) {
    this.escalationChange = false;
    this.observationApplicableChange = false;
    this.ratingMstIdChange = false;
    this.includeInReportChange = false;
    this.auditorObservationChange = false;
    this.impactCommentsChange = false;
    this.recommendationChange = false;
    this.managementCommentChange = false;
    this.targetDateChange = false;
    this.pdcaActionChange = false;
    this.persistenceCommentsChange = false;
    this.revisedTargetDateChange = false;
    this.rcoCommentsChange = false;
    if (index < this.auditorBenchAuditDetailScopeDetailList.length - 1) {
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].executiveSummary !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].executiveSummary
      ) {
        this.escalationChange = true;
      } else {
        this.escalationChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].subObservationParentId !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].subObservationParentId
      ) {
        this.observationApplicableChange = true;
      } else {
        this.observationApplicableChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].ratingMstId !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].ratingMstId
      ) {
        this.ratingMstIdChange = true;
      } else {
        this.ratingMstIdChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].includeInReport !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].includeInReport
      ) {
        this.includeInReportChange = true;
      } else {
        this.includeInReportChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].auditorObservation !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].auditorObservation
      ) {
        this.auditorObservationChange = true;
      } else {
        this.auditorObservationChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].impactComments !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].impactComments
      ) {
        this.impactCommentsChange = true;
      } else {
        this.impactCommentsChange = false;
      }
      if (
        this.auditorBenchAuditDetailScopeDetailList[index].recommendation !=
        this.auditorBenchAuditDetailScopeDetailList[index + 1].recommendation
      ) {
        this.recommendationChange = true;
      } else {
        this.recommendationChange = false;
      }
      if (index < this.auditorBenchAuditDetailScopeDetailList.length - 1) {
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].managementResponse !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].managementResponse
        ) {
          this.managementCommentChange = true;
        } else {
          this.managementCommentChange = false;
        }
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].auditeeTargetDate !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].auditeeTargetDate
        ) {
          this.targetDateChange = true;
        } else {
          this.targetDateChange = false;
        }
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].cdPdcaStatus !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].cdPdcaStatus
        ) {
          this.pdcaActionChange = true;
        } else {
          this.pdcaActionChange = false;
        }
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].persistenceManagementResponse !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].persistenceManagementResponse
        ) {
          this.persistenceCommentsChange = true;
        } else {
          this.persistenceCommentsChange = false;
        }
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].auditeeRevisedTargetDate !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].auditeeRevisedTargetDate
        ) {
          this.revisedTargetDateChange = true;
        } else {
          this.revisedTargetDateChange = false;
        }
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].rcoComments !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].rcoComments
        ) {
          this.rcoCommentsChange = true;
        } else {
          this.rcoCommentsChange = false;
        }
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].modifiedBy !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].modifiedBy
        ) {
          this.modifiedByChange = true;
        } else {
          this.modifiedByChange = false;
        }
        if (
          this.auditorBenchAuditDetailScopeDetailList[index].modifiedOn !=
          this.auditorBenchAuditDetailScopeDetailList[index + 1].modifiedOn
        ) {
          this.modifiedOnChange = true;
        } else {
          this.modifiedOnChange = false;
        }
      }
      return this.escalationChange;
    }
  }
}
